var map = {
	"./m1.png": "./src/assets/img/document/m1.png",
	"./m2.png": "./src/assets/img/document/m2.png",
	"./m3.png": "./src/assets/img/document/m3.png",
	"./m4.png": "./src/assets/img/document/m4.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/document sync recursive ^\\.\\/m.*\\.png$";